import { useFeatureFlag } from '@/hooks/use-feature-flags';
import { PeopleBadgeList } from '@/routes/_layout/scheduling/student-groups/-components/people-badge-list';
import { getSessionSubstitutionRequestSummary } from '@airreading/common';
import {
  AdminSession,
  SubstitutionRequestStatus,
  VideoConferenceType,
  SubstitutionRequestOrigin,
} from '@airreading/common/data';

interface OriginalTeacherDisplayProps {
  session: AdminSession;
}

export const OriginalTeacherDisplay = ({ session }: OriginalTeacherDisplayProps) => {
  const { mostRecentRequest } = getSessionSubstitutionRequestSummary(session);
  const hasPendingRequest = mostRecentRequest?.status === SubstitutionRequestStatus.pending;
  const isAutomaticConflict = mostRecentRequest?.origin === SubstitutionRequestOrigin.automatic_conflict;
  const teacherAvailabilityV2Enabled = useFeatureFlag('teacher-availability-v2', false);
  const isZoom = session.videoConferenceType === VideoConferenceType.zoom;
  const { coach } = session;

  if (teacherAvailabilityV2Enabled && isZoom && hasPendingRequest && isAutomaticConflict) {
    return 'Pending substitute teacher';
  }
  return coach ? <PeopleBadgeList people={[coach]} /> : null;
};
